<span class="star-rating">
  @if(!forDisplay){ @for (n of range; track $index) {

  <i class="fa to-rate" (click)="mark($index)" [ngClass]="isMarked($index)" style="color: #ffc107"></i>
  } }@else if(forDisplay){ @for (n of range; track $index) {

  <i class="to-display fa" [ngClass]="isMarked($index)" style="color: #ffc107"></i>
  } }
</span>